var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2499 14.91C11.2799 15.135 11.2049 15.375 11.0324 15.5325C10.963 15.602 10.8806 15.6572 10.7898 15.6948C10.6991 15.7325 10.6018 15.7518 10.5036 15.7518C10.4054 15.7518 10.3081 15.7325 10.2174 15.6948C10.1267 15.6572 10.0442 15.602 9.97485 15.5325L6.96735 12.525C6.88556 12.445 6.82336 12.3472 6.78563 12.2392C6.7479 12.1313 6.73565 12.016 6.74985 11.9025V8.0625L3.15735 3.465C3.03556 3.30865 2.9806 3.11044 3.0045 2.9137C3.02839 2.71695 3.12918 2.53766 3.28485 2.415C3.42735 2.31 3.58485 2.25 3.74985 2.25H14.2499C14.4149 2.25 14.5724 2.31 14.7149 2.415C14.8705 2.53766 14.9713 2.71695 14.9952 2.9137C15.0191 3.11044 14.9641 3.30865 14.8424 3.465L11.2499 8.0625V14.91ZM5.27985 3.75L8.24985 7.545V11.685L9.74985 13.185V7.5375L12.7199 3.75H5.27985Z",
    fill: "#202F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.54d47c9813102807eeb58aaf31b8e777.svg";
export { ForwardRef as ReactComponent };